import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Shared/Navbar";
import Footer from "../Shared/Footer";

const Mainlayout = () => {
  return (
    <>
      <Navbar />

      <div className="sm:w-[100%] md:w-[100%] lg:w-[90%] mx-auto sm:px-6 py-24 flex-1 min-h-screen">
        <Outlet />
      </div>

      <Footer />
    </>
  );
};

export default Mainlayout;
